import { firestore } from 'firebase/app'
import { Collection } from 'vue-mc'
import { fetch } from './FirestoreCommon'

export default class FirestoreCollection extends Collection {
  fetch (params) { return fetch.call(this, params) }
  save (params) { /* save.call(this, params) */ console.warn('FirestoreCollection.save() not implemented') }
  delete (params) { console.warn('FirestoreCollection.delete() Cannot be implemented') }

  /**
   * @param {Object} snapshot
   *
   * @returns {Array|null} Models from the response.
   */
  getModelsFromResponse (snapshot) {
    let items = []
    snapshot.forEach(item => {
      let attributes = item.data()
      attributes.id = item.id

      // Transform Firebase Timestamps objects to JS Date objects
      for (let attr in attributes) {
        if (attributes[attr] instanceof firestore.Timestamp) {
          attributes[attr] = attributes[attr].toDate()
        }
      }

      items.push(attributes)
    })

    return items
  }

  routes () {
    return {
      fetch: this.collection,
      save: this.collection,
      delete: this.collection
    }
  }
}
